export default __webpack_public_path__ + "static/media/25-2_commentslash.7d492db5.svg";